import { NotificationTypes } from 'constants/notifications';

import { useGetNotifications } from 'shared/widgets/Notification/hooks/useGetNotifications';
import { Notification, NotificationBodyReconciliation } from 'types/embedded/notification';
import { getId } from 'utils/getId';

export function useReconciliationJobNotification(jobId?: number) {
  const { notifications } = useGetNotifications(!!jobId);

  const isViewed = !!notifications?.some(
    (notification) =>
      getId(notification.notificationType) === NotificationTypes.Reconciliation &&
      notification.isViewed &&
      (notification as Notification<NotificationBodyReconciliation>).body.content.jobId === jobId,
  );

  return { isViewed };
}
